module.exports = __webpack_public_path__ + "static/media/29BDOS9.16aec81e.jpg";